// @flow
import * as React from 'react';
import styled from 'styled-components';
import DelimitedInput from 'components/DelimitedInput';
import Input from 'components/Input';

const InputContainer = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
  align-items: center;
`;

const DollarInput = ({ type, ...props }: { type?: string }) => {
  const InputComponent = type === 'number' ? Input : DelimitedInput;
  return (
    <InputContainer>
      <InputComponent
        height="100%"
        width="100%"
        pl="32px"
        type={type}
        {...props}
      />
    </InputContainer>
  );
};

export default DollarInput;
